<form [formGroup]="group">
    <ng-container *ngIf="!extraControlName; else range">
        <!-- DATE -->
        <mat-form-field *ngIf="dateType !== DateType.DATE_TIME; else dateTimeDate" class="w100"
            [class.readonly-field]="readonly" [floatLabel]="readonly ? 'always' : 'auto'" [color]="color">
            <mat-label>{{ label | translate }}</mat-label>
            <input matInput [readonly]="true" [matDatepicker]="datepicker" [min]="minDate" [max]="maxDate"
                [formControlName]="controlName" [placeholder]="placeholder | translate"
                (click)="!readonly && openDatepicker(datepicker)" (dateInput)="dateChanged.emit()"
                (dateChange)="dateChanged.emit()" />
            <mat-datepicker-toggle *ngIf="!control.value" matIconSuffix [for]="datepicker"
                [disabled]="readonly"></mat-datepicker-toggle>
            <div matSuffix *ngIf="!control.disabled && control.value">
                <button mat-icon-button *ngIf="!readonly" (click)="remove()">
                    <mat-icon color="accent">close</mat-icon>
                </button>
            </div>
            <button *ngIf="readonly" matSuffix mat-icon-button tabindex="-1"
                [color]="control.invalid && control.touched  ? 'warn' : ''"
                [matTooltip]="'ALDEN.MESSAGES.INFO.READONLY_FIELDS' | translate" type="button"
                (click)="$event.preventDefault(); $event.stopPropagation()">
                <mat-icon>info</mat-icon>
            </button>
            <mat-hint *ngIf="hint">{{hint}}</mat-hint>
            <mat-datepicker #datepicker (yearSelected)="selectedHandler(controlName, $event, datepicker, DateType.YEAR)"
                (monthSelected)="selectedHandler(controlName, $event, datepicker, DateType.MONTH)"
                [startView]="(dateType === DateType.MONTH || dateType === DateType.YEAR) ? 'multi-year' : (dateType === DateType.MONTH_ONLY) ? 'year' : 'month'"
                [panelClass]="(dateType === DateType.MONTH || dateType === DateType.YEAR) ? 'date-datapicker' : (dateType === DateType.MONTH_ONLY) ? 'date-datapicker-month-only' : ''"
                [touchUi]="false">
            </mat-datepicker>

            <mat-error *ngFor="let error of group.controls[controlName]?.errors | keyvalue">
                <span [ngSwitch]="error.key">
                    <ng-container *ngSwitchCase="'required'">
                        {{ 'ALDEN.VALIDATORS.ERRORS.REQUIRED' | translate }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ error.value | translate }}
                    </ng-container>
                </span>
            </mat-error>
        </mat-form-field>

        <!-- DATE_TIME -->
        <ng-template #dateTimeDate>
            <div class="date-time-fields">
                <!-- Fecha -->
                <mat-form-field class="date-time-date-field" [class.readonly-field]="readonly"
                    [floatLabel]="readonly ? 'always' : 'auto'" [color]="color">

                    <mat-label>{{ label | translate }}</mat-label>

                    <input matInput [formControlName]="controlName" [readonly]="true" [matDatepicker]="dateTimePicker" [min]="minDate" [max]="maxDate"
                        [placeholder]="placeholder | translate"
                        (click)="!readonly && openDatepicker(dateTimePicker)"
                        (dateChange)="onDateChanged()" />

                    <mat-datepicker-toggle *ngIf="!control.value" matIconSuffix [for]="dateTimePicker"
                        [disabled]="readonly">
                    </mat-datepicker-toggle>

                    <div matSuffix *ngIf="!control.disabled && control.value">
                        <button mat-icon-button *ngIf="!readonly" type="button" (click)="remove()">
                            <mat-icon color="accent">close</mat-icon>
                        </button>
                    </div>

                    <button *ngIf="readonly" matSuffix mat-icon-button tabindex="-1"
                        [color]="control.invalid && control.touched ? 'warn' : ''"
                        [matTooltip]="'ALDEN.MESSAGES.INFO.READONLY_FIELDS' | translate" type="button"
                        (click)="$event.preventDefault(); $event.stopPropagation()">
                        <mat-icon>info</mat-icon>
                    </button>

                    <mat-hint *ngIf="hint">
                        {{ hint }}
                    </mat-hint>

                    <mat-datepicker #dateTimePicker startView="month" [touchUi]="false">
                    </mat-datepicker>

                    <mat-error *ngFor="let error of group.controls[controlName]?.errors | keyvalue">
                        <span [ngSwitch]="error.key">
                            <ng-container *ngSwitchCase="'required'">
                                {{ 'ALDEN.VALIDATORS.ERRORS.REQUIRED' | translate }}
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                                {{ error.value | translate }}
                            </ng-container>
                        </span>
                    </mat-error>
                </mat-form-field>

                <!-- Hora -->
                <mat-form-field class="date-time-time-field" [class.readonly-field]="readonly"
                    [floatLabel]="readonly ? 'always' : 'auto'" [color]="color">
                    <mat-label>{{ 'ALDEN.LABELS.HOUR' | translate }}</mat-label>
                    <input matInput type="time" [readonly]="readonly" [value]="dateTimeTime" [disabled]="control.disabled"
                        (change)="timeChanged($event)" />
                </mat-form-field>
            </div>
        </ng-template>
    </ng-container>

    <ng-template #range>
        <!--  RANGE DATE -->
        <ng-container *ngIf="dateType === DateType.RANGE">
            <mat-form-field class="w100" [class.readonly-field]="readonly" [floatLabel]="readonly ? 'always' : 'auto'"
                [color]="color">
                <mat-label>
                    {{ label | translate }}
                    <span>{{isRequired(controlName, group) ? '*' : ''}}</span>
                </mat-label>
                <mat-date-range-input [rangePicker]="startenddatedatepicker"
                    (click)="openDatepicker(startenddatedatepicker)" (dateChange)="dateChanged.emit()">
                    <input matStartDate [min]="minDate" [readonly]="readonly" [formControlName]="controlName"
                        [placeholder]="placeholder ? (placeholder | translate) : ''" (change)="dateChanged.emit()">
                    <input matEndDate [max]="maxDate" [readonly]="readonly" [formControlName]="extraControlName"
                        [placeholder]="extraPlaceholder ? (extraPlaceholder | translate) : ''"
                        (change)="dateChanged.emit()">
                </mat-date-range-input>
                <mat-hint *ngIf="hint">{{hint}}</mat-hint>
                <mat-date-range-picker #startenddatedatepicker startView="month"></mat-date-range-picker>
                <mat-datepicker-toggle *ngIf="(!control.value && !extraControl.value) || readonly" matIconSuffix
                    [for]="startenddatedatepicker" [disabled]="readonly"></mat-datepicker-toggle>
                <div matSuffix *ngIf="!control.disabled && (control.value || extraControl.value)">
                    <button mat-icon-button *ngIf="!readonly" (click)="remove()">
                        <mat-icon color="accent">close</mat-icon>
                    </button>
                </div>
                <button *ngIf="readonly" matSuffix mat-icon-button tabindex="-1"
                    [color]="control.invalid && control.touched  ? 'warn' : ''"
                    [matTooltip]="'ALDEN.MESSAGES.INFO.READONLY_FIELDS' | translate" type="button"
                    (click)="$event.preventDefault(); $event.stopPropagation()">
                    <mat-icon>info</mat-icon>
                </button>
                <mat-error *ngFor="let error of group.controls[controlName]?.errors | keyvalue">
                    <span [ngSwitch]="error.key">
                        <ng-container *ngSwitchCase="'required'">
                            {{ 'ALDEN.VALIDATORS.ERRORS.REQUIRED' | translate }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ error.value | translate }}
                        </ng-container>
                    </span>
                </mat-error>
            </mat-form-field>
        </ng-container>
        <!--  RANGE_MONTH Y RANGE_YEAR -->
        <div *ngIf="dateType !== DateType.RANGE" class="range-div">
            <!--  RANGE START -->
            <mat-form-field class="w50" [class.readonly-field]="readonly" [floatLabel]="readonly ? 'always' : 'auto'"
                [color]="color">
                <mat-label>{{ placeholder | translate }}</mat-label>
                <input matInput [min]="minDate" [readonly]="true" [matDatepicker]="startDatepicker"
                    [formControlName]="controlName" (click)="!readonly && openDatepicker(startDatepicker)"
                    (dateInput)="dateChanged.emit()" (dateChange)="dateChanged.emit()" />
                <mat-datepicker-toggle *ngIf="!control.value" matIconSuffix [for]="startDatepicker"
                    [disabled]="readonly"></mat-datepicker-toggle>
                <div matSuffix *ngIf="!control.disabled && control.value">
                    <button mat-icon-button *ngIf="!readonly" (click)="remove(control)">
                        <mat-icon color="accent">close</mat-icon>
                    </button>
                </div>
                <button *ngIf="readonly" matSuffix mat-icon-button tabindex="-1"
                    [color]="control.invalid && control.touched  ? 'warn' : ''"
                    [matTooltip]="'ALDEN.MESSAGES.INFO.READONLY_FIELDS' | translate" type="button"
                    (click)="$event.preventDefault(); $event.stopPropagation()">
                    <mat-icon>info</mat-icon>
                </button>
                <mat-hint *ngIf="hint">{{hint}}</mat-hint>
                <mat-datepicker #startDatepicker
                    (yearSelected)="selectedHandler(controlName, $event, startDatepicker, DateType.YEAR)"
                    (monthSelected)="selectedHandler(controlName, $event, startDatepicker, DateType.MONTH)"
                    [startView]="'multi-year'" [panelClass]="'date-datapicker'" [touchUi]="false">
                </mat-datepicker>
                <mat-error *ngFor="let error of group.controls[controlName]?.errors | keyvalue">
                    <span [ngSwitch]="error.key">
                        <ng-container *ngSwitchCase="'required'">
                            {{ 'ALDEN.VALIDATORS.ERRORS.REQUIRED' | translate }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ error.value | translate }}
                        </ng-container>
                    </span>
                </mat-error>
            </mat-form-field>

            <!--  RANGE END -->
            <mat-form-field class="w50" [class.readonly-field]="readonly" [floatLabel]="readonly ? 'always' : 'auto'"
                [color]="color">
                <mat-label>{{ extraPlaceholder | translate }}</mat-label>
                <input matInput [max]="maxDate" [readonly]="true" [matDatepicker]="endDatepicker"
                    [formControlName]="extraControlName" (click)="!readonly && openDatepicker(endDatepicker)"
                    (dateInput)="dateChanged.emit()" (dateChange)="dateChanged.emit()" />
                <mat-datepicker-toggle *ngIf="!extraControl.value" matIconSuffix [for]="endDatepicker"
                    [disabled]="readonly"></mat-datepicker-toggle>
                <div matSuffix *ngIf="!extraControl.disabled && extraControl.value">
                    <button mat-icon-button *ngIf="!readonly" (click)="remove(extraControl)">
                        <mat-icon color="accent">close</mat-icon>
                    </button>
                </div>
                <button *ngIf="readonly" matSuffix mat-icon-button tabindex="-1"
                    [color]="control.invalid && control.touched  ? 'warn' : ''"
                    [matTooltip]="'ALDEN.MESSAGES.INFO.READONLY_FIELDS' | translate" type="button"
                    (click)="$event.preventDefault(); $event.stopPropagation()">
                    <mat-icon>info</mat-icon>
                </button>
                <mat-hint *ngIf="hint">{{hint}}</mat-hint>
                <mat-datepicker #endDatepicker
                    (yearSelected)="selectedHandler(extraControlName, $event, endDatepicker, DateType.YEAR)"
                    (monthSelected)="selectedHandler(extraControlName, $event, endDatepicker, DateType.MONTH)"
                    [startView]="'multi-year'" [panelClass]="'date-datapicker'" [touchUi]="false">
                </mat-datepicker>
                <mat-error *ngFor="let error of group.controls[controlName]?.errors | keyvalue">
                    <span [ngSwitch]="error.key">
                        <ng-container *ngSwitchCase="'required'">
                            {{ 'ALDEN.VALIDATORS.ERRORS.REQUIRED' | translate }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ error.value | translate }}
                        </ng-container>
                    </span>
                </mat-error>
            </mat-form-field>
        </div>
    </ng-template>
</form>